import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { getDownloadURL, ref, listAll } from 'firebase/storage'; // Importa Firebase Storage
import { storage } from '../../../firebase/firebaseConfig';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

const SeccionFotosMisDiseños = () => {
    const [imagenesMisDiseños, setImagenesMisDiseños] = useState([]);

    // Obtener las imágenes de Firebase Storage
    useEffect(() => {
        const fetchImages = async () => {
            const listRef = ref(storage, 'fotoslistamisdiseñoscalocho/'); // Ruta a la carpeta en Firebase Storage
            const res = await listAll(listRef); // Obtener todos los archivos de la carpeta

            // Obtener las URLs de las imágenes
            const urls = await Promise.all(
                res.items.map(async (itemRef) => {
                    const url = await getDownloadURL(itemRef); // Obtener la URL de cada imagen
                    return { url, name: itemRef.name }; // Retorna un objeto con URL y nombre
                })
            );
            setImagenesMisDiseños(urls); // Guardar las URLs en el estado
        };

        fetchImages();
    }, []);

    return(
        <Box xs={10} md={10} lg={9} sx={{ 
            position: 'static', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            width: { xs: '100%', sm: '90%', md: '80%', lg: '70%' },
            height: 'auto', 
            margin: { xs: '10px', sm: '20px', md: '40px' }, 
            maxHeight: { xs: '70vh', sm: '80vh', md: '90vh' },
            top: '55%',
            overflowY: 'scroll', // Habilita el scroll vertical
            
            // Estilos para ocultar el scroll
            '&::-webkit-scrollbar': {
                display: 'none', // Chrome, Safari y Opera
            },
            '-ms-overflow-style': 'none', // IE y Edge
            'scrollbar-width': 'none', // Firefox
        }}>
            <ImageList variant="masonry" cols={3} gap={8}>
            {imagenesMisDiseños.map((imagenesmisdiseños) => (
                <ImageListItem key={imagenesmisdiseños.url}>
                <img
                    srcSet={imagenesmisdiseños.url}
                    src={imagenesmisdiseños.name}
                    alt={imagenesmisdiseños.name}
                    loading="lazy"
                    style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                />
                </ImageListItem>
            ))}
            </ImageList>
        </Box>
    );
}

export default SeccionFotosMisDiseños;